import { combineReducers } from "redux"

import { sessionReducer } from "./session"
import { translationReducer } from "./translation"

export default combineReducers({
  sessionReducer,
  translationReducer
})
